import React, { useEffect } from "react";
import { imagePath } from "../../../../config/DataService";

const PrintSahayApplication = React.forwardRef(
  ({ 
    formData, 
    state, 
    familyMembers, 
    editSingleApplicantData
  }, ref) => {

    const committees = JSON.parse(state?.committeeApprovalName || "[]");

    return (
      <div ref={ref} style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
        <h1 style={{ textAlign: "center", fontSize: "24px", marginBottom: "20px" }}>
          Application Form
        </h1>

        {/* Document Section */}
        {formData?.document
          ?.map((data) => ({
            documentType: data.documentType,
            documents: data.documents?.filter((doc) => doc.document !== "null"),
          }))
          ?.filter((item) => item.documents?.length > 0)
          ?.map((item, fileIndex) => (
            <div key={fileIndex} style={{ marginBottom: "20px" }}>
              <h3 style={{ fontSize: "18px", marginBottom: "10px" }}>{item.documentType}</h3>

              {item.documents.map((document, documentIndex) => {
                const fileURL =
                  document instanceof Blob
                    ? URL.createObjectURL(document)
                    : `${imagePath}${document?.filename}`;
                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(document?.document || ""); // Check if it's an image

                return (
                  <div
                    key={documentIndex}
                    style={{
                      marginBottom: "10px",
                      padding: "5px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      backgroundColor: "#f9f9f9",
                      textAlign: "center",
                    }}
                  >
                    {isImage ? (
                      <img
                        src={fileURL}
                        alt="Document"
                        style={{ maxWidth: "100%", height: "auto", cursor: "pointer" }}
                        onClick={() => window.open(fileURL, "_blank")}
                      />
                    ) : (
                      <a
                        href={fileURL}
                        style={{ color: "#007bff", textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {document instanceof Blob ? document.name : document?.document}
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          ))}

        {/* Main Application Details */}
        <table style={styles.table}>
          <tbody>
            {[
              { label: "Total Requested Sahay Amount", value: formData?.application[0]?.claimedAmmount },
              { label: "Approve Amount", value: formData?.application[0]?.approveAmount },
              { label: "Family ID", value: state?.familyId },
              { label: "Aadhar Card No.", value: formData?.application[0]?.AadharNo },
              { label: "Sahay Category", value: formData?.application[0]?.SahayName },
              { label: "Sub Sahay Category", value: formData?.application[0]?.subSahayName },
              { label: "Year Of Sahay", value: formData?.application[0]?.Year || `${formData?.application[0]?.fromYear}-${formData?.application[0]?.toYear}` },
              { label: "Remark", value: formData?.application[0]?.remark },
              { label: "Application Received Date", value: formData?.application[0]?.applicationReceiveDate },
              { label: "Filing Date", value: formData?.application[0]?.formFillingDate },
              { label: "Name Of Applicant", value: formData?.application[0]?.Name },
              { label: "First Name", value: formData?.application[0]?.firstName },
              { label: "Middle Name", value: formData?.application[0]?.middleName },
              { label: "Last Name", value: formData?.application[0]?.lastName },
              { label: "Relation", value: editSingleApplicantData?.relation || formData?.application[0]?.relation },
              { label: "Age", value: formData?.application[0]?.age },
              { label: "Working Type", value: formData?.application[0]?.workingType },
              { label: "Beneficiary Name ", value: formData?.application[0]?.beneficiaryMemName },
              { label: "Family Income", value: formData?.application[0]?.monthlyIncome },
              { label: "Electric Bill amount", value: formData?.application[0]?.threeMonthBillAmount },
            
              {
                label: "Reference / Guarantor",
                value: formData?.application?.[0]?.patanMandalMember
                  ? `${formData?.PatanMemberData?.[0]?.mem_family_id} ${formData?.PatanMemberData?.[0]?.mem_fname} ${formData?.PatanMemberData?.[0]?.mem_mname} ${formData?.PatanMemberData?.[0]?.mem_lname}`
                  : `${formData?.application[0]?.patanReferenceName}`,
              },
              { label: "Mohalla Name", value: formData?.application[0]?.patanMandalMember ? formData?.PatanMemberData?.[0]?.mohollo_name : formData?.application?.[0]?.patanReferenceMohollo },
              { label: "Mobile Number", value: formData?.application[0]?.patanMemberMobile },
              { label: "Area", value: formData?.application[0]?.patanMandalMember ? formData?.PatanMemberData?.[0]?.family_area : formData?.application?.[0]?.patanReferenceArea },
              { label: "Type Of Disease", value: formData?.application[0]?.disease },
              { label: "Bank Name", value: formData?.application[0]?.bankName },
              { label: "Branch", value: formData?.application[0]?.branch },
              { label: "Account Holder Name", value: formData?.application[0]?.HolderName },
              { label: "Account Number", value: formData?.application[0]?.AccountNo },
              { label: "IFSC code", value: formData?.application[0]?.IFSCCode },
              { label: "First Commite Name", value: committees[0]?.committeeName || "-" },
              { label: "First Commite Remark", value: state?.approveCommitteRemark || "-" },
              { label: "Second Commite Name", value: committees[1]?.committeeName || "-" },
              { label: "Second Commite Remark", value: state?.approveCommitteRemarkSec || "-" },
            ].map((row, index) => (
              <tr key={index}>
                <th style={styles.th}>{row.label}</th>
                <td style={styles.td}>{row.value || "N/A"}</td>
              </tr>
            ))}

            {formData?.application[0]?.isLoan === true ? (
              <tr>
                <th style={styles.th}>PAN Card No.</th>
                <td style={styles.td}>{formData?.application?.[0]?.PANCardNo || "N/A"}</td>
              </tr>
            ) : null}
          </tbody>
        </table>

        {/* Family Members Table */}
        {familyMembers?.length ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>Age</th>
                <th style={styles.th}>Relation</th>
                <th style={styles.th}>Working Type</th>
              </tr>
            </thead>
            <tbody>
              {familyMembers
                ?.filter((ele) => ele?.id !== formData?.application?.[0]?.applicantId)
                ?.map((data, index) => (
                  <tr key={index}>
                    <td style={styles.td}>{`${data?.firstName} ${data?.middleName} ${data?.lastName}` || "-"}</td>
                    <td style={styles.td}>{data?.age || "-"}</td>
                    <td style={styles.td}>{data?.relation || "-"}</td>
                    <td style={styles.td}>{data?.workingType || "-"}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <p>No family members data available</p>
        )}
      </div>
    );
  }
);

// Styles
const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    marginBottom: "30px",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  th: {
    textAlign: "left",
    padding: "12px",
    border: "1px solid #ccc",
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    fontSize: "14px",
  },
  td: {
    padding: "12px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
};

export default PrintSahayApplication;
